import React from 'react';
import './todo.css';

const Todo = ({ text, setTodos, todos, todo }) => {
  const deleteHandler = () => {
    setTodos(todos.filter((el) => el.id !== todo.id));
  };
  const completeHandler = () => {
    setTodos(
      todos.map((item) => {
        if (item.id === todo.id) {
          return {
            ...item,
            completed: !item.completed,
          };
        }
        return item;
      })
    );
  };
  const importantHandler = () => {
    setTodos(
      todos.map((item) => {
        if (item.id === todo.id) {
          return {
            ...item,
            important: !item.important,
          };
        }
        return item;
      })
    );
  };
  return (
    <div
      className={`toDo ${todo.completed ? 'toDo--checked' : ''}  ${
        todo.important ? 'toDo__item--important' : ''
      }`}
      draggable='true'
    >
      <li onClick={completeHandler} className='toDo__item'>
        {text}
      </li>
      <button onClick={deleteHandler} className='trash-btn'></button>
      <button
        onClick={importantHandler}
        className={`important-btn ${todo.important ? 'not-important-btn' : ''}`}
      >
        MARK IMPORTANT
      </button>
    </div>
  );
};

export default Todo;
